(function () {
  'use strict';

  if (window.biancelleCommerceReady) return;
  window.biancelleCommerceReady = true;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var feedbackTimers = new WeakMap();

  function animate(element, frames, options) {
    if (!element || reducedMotion.matches || typeof element.animate !== 'function') return;
    element.animate(frames, Object.assign({ duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' }, options || {}));
  }

  function pulse(element, className) {
    if (!element || reducedMotion.matches) return;
    element.classList.remove(className);
    window.requestAnimationFrame(function () {
      element.classList.add(className);
      window.setTimeout(function () { element.classList.remove(className); }, 700);
    });
  }

  class BiancelleProductDock extends HTMLElement {
    connectedCallback() {
      this.productRoot = this.closest('product-info');
      this.mainProductForm = this.productRoot && this.productRoot.querySelector('product-form');
      this.mainForm = this.mainProductForm && this.mainProductForm.querySelector('form');
      this.mainButton = this.mainProductForm && this.mainProductForm.querySelector('button[type="submit"]');
      this.priceSource = this.productRoot && this.productRoot.querySelector('[id^="price-"]');
      this.buyButton = this.querySelector('[data-bi-dock-submit]');
      this.buyLabel = this.querySelector('[data-bi-dock-label]');
      this.priceLabel = this.querySelector('[data-bi-dock-price]');
      this.statusLabel = this.querySelector('[data-bi-dock-status]');
      if (!this.mainForm || !this.mainButton || !this.buyButton) return;

      this.pastButton = false;
      this.footerVisible = false;
      this.dockVisible = undefined;
      this.onBuy = this.submitOriginalForm.bind(this);
      this.onAddState = this.handleAddState.bind(this);
      this.onScroll = this.schedulePosition.bind(this);
      this.buyButton.addEventListener('click', this.onBuy);
      document.addEventListener('biancelle:cart-add', this.onAddState);
      this.syncObserver = new MutationObserver(this.sync.bind(this));
      this.syncObserver.observe(this.mainProductForm, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'value']
      });
      if (this.priceSource) {
        this.syncObserver.observe(this.priceSource, {
          subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']
        });
      }
      if ('IntersectionObserver' in window) {
        this.positionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target === this.mainButton) {
              this.pastButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            } else {
              this.footerVisible = entry.isIntersecting;
            }
          }, this);
          this.updateVisibility();
        }.bind(this));
        this.positionObserver.observe(this.mainButton);
        var footer = document.querySelector('footer.footer');
        if (footer) this.positionObserver.observe(footer);
      } else {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.schedulePosition();
      }
      this.hidden = false;
      this.sync();
      this.updateVisibility();
    }

    disconnectedCallback() {
      if (this.syncObserver) this.syncObserver.disconnect();
      if (this.positionObserver) this.positionObserver.disconnect();
      if (this.buyButton) this.buyButton.removeEventListener('click', this.onBuy);
      document.removeEventListener('biancelle:cart-add', this.onAddState);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.clearTimeout(this.statusTimer);
      window.cancelAnimationFrame(this.positionFrame);
    }

    schedulePosition() {
      if (this.positionFrame) return;
      this.positionFrame = window.requestAnimationFrame(function () {
        this.positionFrame = null;
        this.pastButton = this.mainButton.getBoundingClientRect().bottom < 0;
        this.updateVisibility();
      }.bind(this));
    }

    updateVisibility() {
      var visible = this.pastButton && !this.footerVisible;
      if (this.dockVisible === visible) return;
      this.dockVisible = visible;
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      this.inert = !visible;
    }

    sync() {
      var pending = this.mainButton.classList.contains('loading');
      var unavailable = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      var disabled = pending || unavailable;
      if (this.buyButton.disabled !== disabled) this.buyButton.disabled = disabled;
      var busy = pending ? 'true' : 'false';
      if (this.buyButton.getAttribute('aria-busy') !== busy) this.buyButton.setAttribute('aria-busy', busy);
      var mainLabel = this.mainButton.querySelector('span');
      var label = pending ? 'Se adaugă…' : (mainLabel ? mainLabel.textContent.trim() : 'Adaugă în coș');
      if (this.buyLabel.textContent !== label) this.buyLabel.textContent = label;
      var priceText = '';
      if (this.priceSource && !this.priceSource.classList.contains('hidden')) {
        var price = this.priceSource.querySelector('.price');
        var priceValue = price && price.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
        priceText = priceValue ? priceValue.textContent.trim() : '';
      }
      if (this.priceLabel.textContent !== priceText) this.priceLabel.textContent = priceText;
    }

    submitOriginalForm() {
      this.sync();
      if (this.buyButton.disabled) return;
      this.statusLabel.textContent = '';
      if (typeof this.mainForm.requestSubmit === 'function') {
        this.mainForm.requestSubmit(this.mainButton);
      } else {
        this.mainButton.click();
      }
    }

    handleAddState(event) {
      if (event.target !== this.mainProductForm) return;
      if (event.detail.phase !== 'complete') window.clearTimeout(this.statusTimer);
      if (event.detail.phase === 'success') {
        this.statusLabel.textContent = 'Adăugat în coș. Bună alegere.';
        this.statusTimer = window.setTimeout(function () { this.statusLabel.textContent = ''; }.bind(this), 4500);
      } else if (event.detail.phase === 'error') {
        this.statusLabel.textContent = event.detail.message || 'Nu am putut adăuga produsul. Încearcă din nou.';
      } else if (event.detail.phase === 'start') {
        this.statusLabel.textContent = '';
      }
      this.sync();
    }
  }
  if (!customElements.get('biancelle-product-dock')) {
    customElements.define('biancelle-product-dock', BiancelleProductDock);
  }

  document.addEventListener('biancelle:cart-add', function (event) {
    if (event.detail.phase === 'complete') return;
    var form = event.target;
    if (!(form instanceof Element)) return;
    var feedback = form.querySelector('[data-bi-add-feedback]');
    window.clearTimeout(feedbackTimers.get(form));
    if (event.detail.phase === 'start') {
      form.classList.remove('bi-is-added');
      if (feedback) feedback.textContent = '';
    }
    if (event.detail.phase === 'success') {
      form.classList.add('bi-is-added');
      if (feedback) feedback.textContent = 'E în coș. Bună alegere.';
      pulse(document.getElementById('cart-icon-bubble'), 'bi-cart-icon-pop');
      feedbackTimers.set(form, window.setTimeout(function () {
        form.classList.remove('bi-is-added');
        if (feedback) feedback.textContent = '';
      }, 4500));
    }
    if (event.detail.phase === 'error') {
      form.classList.remove('bi-is-added');
      if (feedback) feedback.textContent = '';
    }
  });

  document.addEventListener('biancelle:cart-change', function (event) {
    var detail = event.detail;
    var drawer = detail.context === 'drawer';
    var row = document.getElementById((drawer ? 'CartDrawer-Item-' : 'CartItem-') + detail.line);
    if (detail.phase === 'start') {
      if (row) {
        row.classList.add('bi-line-pending');
        row.classList.toggle('bi-line-removing', detail.quantity === 0);
      }
      return;
    }
    document.querySelectorAll('.bi-line-pending, .bi-line-removing').forEach(function (item) {
      item.classList.remove('bi-line-pending', 'bi-line-removing');
    });
    if (detail.phase !== 'success') return;
    var scope = drawer ? document.querySelector('cart-drawer') : document.querySelector('#MainContent');
    if (!scope) return;
    scope.querySelectorAll('[data-bi-cart-total]').forEach(function (total) {
      pulse(total, 'bi-cart-total-updated');
    });
    if (row && detail.quantity !== 0) {
      animate(row, [{ backgroundColor: '#c6f6ee' }, { backgroundColor: '#ffffff' }], { duration: 700 });
    }
    pulse(document.getElementById('cart-icon-bubble'), 'bi-cart-icon-pop');
  });

  function initialize(root) {
    document.documentElement.classList.add('bi-commerce-ready');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { initialize(document); });
  }
})();
